module.exports = __webpack_public_path__ + "static/media/react.9a28da9f.svg";